module.exports = __webpack_public_path__ + "static/media/two_sending_waves@2x.460f612e.png";